class AccountCertificate {
  type: string;
  file: string;
  pdfPages: number;
  documentId: number;
  filePath: string;

  constructor(type: string, file: string, pdfPages: number, documentId: number, filePath: string) {
    this.type = type;
    this.file = file;
    this.pdfPages = pdfPages;
    this.documentId = documentId;
    this.filePath = filePath;
  }
}

export { AccountCertificate };
